if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.touchEndX = 0;
        this.touchEndY = 0;
        this.galleryReady = false;
      }

      getMedia() {
        return Array.from(
          this.querySelectorAll(
            '.product-media-modal__content > [data-media-id]'
          )
        ).filter((el) => !el.classList.contains('variant-image'));
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.setupGallery();
      }

      hide() {
        super.hide();
      }

      showActiveMedia() {
        const media = this.getMedia();
        const mediaId = this.openedBy?.getAttribute('data-media-id');

        const index = media.findIndex(
          (el) => el.getAttribute('data-media-id') === mediaId
        );

        this.showSlide(index >= 0 ? index : 0);
      }

      showSlide(index) {
        const media = this.getMedia();
        if (!media.length) return;

        this.currentIndex =
          (index + media.length) % media.length;

        media.forEach((el, i) => {
          el.classList.toggle('active', i === this.currentIndex);
          el.style.display = i === this.currentIndex ? 'flex' : 'none';
        });

        const active = media[this.currentIndex];
        const template = active.querySelector('template');

        if (
          active.nodeName === 'DEFERRED-MEDIA' &&
          template?.content.querySelector('.js-youtube')
        ) {
          active.loadContent();
        }

        const counter = this.querySelector('.alc-gallery-counter');
        if (counter) {
          counter.textContent =
            `${this.currentIndex + 1} / ${media.length}`;
        }

        this.querySelector('.product-media-modal__content')
          ?.scrollTo({ top: 0, left: 0 });
      }

      setupGallery() {
        if (this.galleryReady) return;
        this.galleryReady = true;

        const content = this.querySelector(
          '.product-media-modal__content'
        );

        const controls = document.createElement('div');
        controls.className = 'alc-gallery-controls';
        controls.innerHTML = `
          <button type="button" class="alc-gallery-prev"
            aria-label="Previous photo">&#10094;</button>
          <span class="alc-gallery-counter"></span>
          <button type="button" class="alc-gallery-next"
            aria-label="Next photo">&#10095;</button>
        `;

        this.querySelector('.product-media-modal__dialog')
          .appendChild(controls);

        controls.querySelector('.alc-gallery-prev')
          .addEventListener('click', () =>
            this.showSlide(this.currentIndex - 1)
          );

        controls.querySelector('.alc-gallery-next')
          .addEventListener('click', () =>
            this.showSlide(this.currentIndex + 1)
          );

        content.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
          this.touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });

        content.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.touchEndY = e.changedTouches[0].screenY;

          const dx = this.touchEndX - this.touchStartX;
          const dy = this.touchEndY - this.touchStartY;

          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            this.showSlide(
              this.currentIndex + (dx < 0 ? 1 : -1)
            );
          }
        }, { passive: true });

        this.addEventListener('keydown', (e) => {
          if (!this.classList.contains('active')) return;
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.showSlide(this.currentIndex + 1);
          }
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.showSlide(this.currentIndex - 1);
          }
        });

        this.showSlide(this.currentIndex);
      }
    }
  );
}
